import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import trLocale from '@fullcalendar/core/locales/tr'

const activityDate = (() => {

  // const weekPickerInit = () => {
  //   const calendarEl = document.getElementById('calendar');

  //     const calendar = new Calendar(calendarEl, {
  //       plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
  //       locale: trLocale,
  //       initialView: 'timeGridWeek',
  //       customButtons: {
  //         ziyaretBtn: {
  //           text: 'Ziyaret Randevusu Oluştur',
  //           click: function() {
  //             const btn = document.querySelector('.fc-ziyaretBtn-button');
  //             if (btn) {
  //               btn.setAttribute('data-fancybox', '');
  //               btn.setAttribute('data-src', '#calendar-modal');
  //             }
  //             // İstersen burada modal açma işlemini de tetikleyebilirsin
  //           }
  //         }
  //       },
  //       headerToolbar: {
  //         left: 'prev,next today',
  //         center: 'title',
  //         right: 'ziyaretBtn timeGridDay,timeGridWeek'
  //       },
  //       slotMinTime: "09:00:00",
  //       slotMaxTime: "17:00:00",
  //       slotDuration: "01:00:00", // <-- 1 saatlik slotlar
  //       dayHeaderContent: function(arg) {
  //         // arg.date: Date objesi
  //         // arg.text: default başlık metni
  //         const gunler = ['PZR', 'PZT', 'SAL', 'ÇAR', 'PER', 'CUM', 'CMT'];
  //         const dayName = gunler[arg.date.getDay()];
  //         const day = arg.date.getDate().toString().padStart(2, '0');
  //         const month = (arg.date.getMonth() + 1).toString().padStart(2, '0');
  //         return {
  //           html: `<div class="day-header-name">${dayName}</div><div class="day-header-date">${day}/${month}</div>`
  //         };
  //       },
  //       editable: true,
  //       selectable: true,
  //       events: [
  //         {
  //           title: 'Dolu Randevu',
  //           start: '2025-07-08T10:00:00',
  //           end: '2025-07-08T11:00:00',
  //           type: 'once', // önceden yapılmış
  //         },
  //         {
  //           title: 'Yeni Randevu',
  //           start: '2025-07-09T11:00:00',
  //           end: '2025-07-09T12:00:00',
  //           type: 'yeni', // şimdi yapılacak
  //         },
  //         {
  //           title: 'Ziyaret Randevusu Oluştur',
  //           start: '2025-07-11T12:00:00', // Cuma günü saat 12:00
  //           end: '2025-07-11T13:00:00',
  //           display: 'block',
  //           classNames: ['ziyaret-randevu-btn'],
  //           extendedProps: {
  //             isZiyaretBtn: true
  //           }
  //         },
  //         {
  //           title: 'Ziyaret Randevusu Oluştur',
  //           start: '2025-07-11T13:00:00', // Cuma günü saat 12:00
  //           end: '2025-07-11T14:00:00',
  //           display: 'block',
  //           classNames: ['ziyaret-randevu-btn'],
  //           extendedProps: {
  //             isZiyaretBtn: true
  //           }
  //         },
  //         {
  //           title: 'Ziyaret Randevusu Oluştur',
  //           start: '2025-07-11T14:00:00', // Cuma günü saat 12:00
  //           end: '2025-07-11T15:00:00',
  //           display: 'block',
  //           classNames: ['ziyaret-randevu-btn'],
  //           extendedProps: {
  //             isZiyaretBtn: true
  //           }
  //         }
  //       ],
  //       select: function(info) {
  //         const title = prompt('Etkinlik Adı:');
  //         if (title) {
  //           calendar.addEvent({
  //             title: title,
  //             start: info.startStr,
  //             end: info.endStr,
  //             allDay: info.allDay,
  //             classNames: ['yeni-randevu']
  //           });
  //         }
  //       },
  //       eventClassNames: function(arg) {
  //         if (arg.event.extendedProps.type === 'once') {
  //           return ['once-randevu'];
  //         }
  //         if (arg.event.extendedProps.type === 'yeni') {
  //           return ['yeni-randevu'];
  //         }
  //         return [];
  //       },
  //       dayCellDidMount: function(arg) {
  //         // Sadece timeGridWeek ve timeGridDay görünümlerinde çalışır
  //         // arg.date.getDay() -> 0: Pazar, 6: Cumartesi
  //         if (arg.date.getDay() === 0 || arg.date.getDay() === 6) {
  //           arg.el.style.background = 'rgba(238, 238, 238, 1)';
  //           // Randevu eklemeyi engellemek için selectable'ı kontrol et
  //           arg.el.classList.add('fc-disabled-day');
  //         }
  //       },
  //       selectAllow: function(selectInfo) {
  //         // Cumartesi veya Pazar seçimini engelle
  //         const startDay = selectInfo.start.getDay();
  //         const endDay = selectInfo.end.getDay();
  //         if (startDay === 0 || startDay === 6 || endDay === 0 || endDay === 6) {
  //           return false;
  //         }
  //         return true;
  //       },
  //       eventClick: function(info) {
  //         if (info.event.extendedProps.isZiyaretBtn) {
  //           // Burada modal açabilir veya form gösterebilirsin
  //           // alert('Ziyaret Randevusu Oluştur butonuna tıkladınız!');
  //           // info.jsEvent.preventDefault();
  //         }
  //       },
  //       eventContent: function(arg) {
  //         if (arg.event.extendedProps.isZiyaretBtn) {
  //           // Sadece özel HTML döndür
  //           return { html: '<div class="new-pop-activity" data-fancybox="" data-src="#calendar-modal"><div class="plus">+</div><div class="text">Ziyaret Randevusu Oluştur</div></div>' };
  //         }
  //         // Diğer eventler için default davranış
  //         return true;
  //       }
  //     });

  //     calendar.render();

  //     // Butonun DOM elementine attribute ekle
  //     const ziyaretBtns = document.querySelectorAll('.fc-ziyaretBtn-button');
  //     ziyaretBtns.forEach(btn => {
  //       btn.setAttribute('data-fancybox', '');
  //       btn.setAttribute('data-src', '#calendar-modal');
  //     });
  // };

  const init = () => {
    // weekPickerInit(); // <-- Haftalık datepicker başlat
  };

  return {
    init,
  };
})();

export default activityDate;
